var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject } from "aurelia-dependency-injection";
import { BrandingPreviewBase } from "../../branding/branding-preview-base";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { StepEnum } from "../../../../../models/modules/lotteryplatofrm.models";
import { BundleBrandingText } from "./branding-steps/bundle-branding-text";
import { BundleBrandingColors } from "./branding-steps/bundle-branding-colors";
import { EventAggregator } from "aurelia-event-aggregator";
import { BundleBrandingImages } from "./branding-steps/bundle-branding-images";
import { I18N } from "aurelia-i18n";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { TokenClient } from "../../../../../services/authentication/token-client.service";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { BrandClientService, BundleKeyHelper, TemplateType } from "../../../../../services/modules/brand-client.service";
import { AttachmentClientService } from "../../../../../services/modules/attachements-client.service";
import { CacheClient } from "../../../../../services/basics/client-caching.service";
import { BundleBrandingAds } from "./branding-steps/bundle-branding-ads";
import { BundleBrandingAssets } from "./branding-steps/bundle-branding-assets";
import { JsonLockClientService } from "../../../../../services/modules/json-lock-client-service";
var BundleBrandingDialog = /** @class */ (function (_super) {
    __extends(BundleBrandingDialog, _super);
    function BundleBrandingDialog(element, notificationService, i18N, eventAggregator, lookupClientService, cacheClient, bundleBrandingText, bundleBrandingImages, bundleBrandingAds, bundleBrandingColors, bundleBrandingAssets, tokenClientService, dialogClientService, brandClientService, attachmentClientService, jsonLockClientService) {
        var _this = _super.call(this, element, notificationService, i18N, eventAggregator, tokenClientService, lookupClientService, dialogClientService, brandClientService, attachmentClientService, cacheClient, jsonLockClientService) || this;
        _this.bundleBrandingText = bundleBrandingText;
        _this.bundleBrandingImages = bundleBrandingImages;
        _this.bundleBrandingAds = bundleBrandingAds;
        _this.bundleBrandingColors = bundleBrandingColors;
        _this.bundleBrandingAssets = bundleBrandingAssets;
        return _this;
    }
    BundleBrandingDialog.prototype.getFilesToSave = function () {
        return [TemplateType.Bundle];
    };
    BundleBrandingDialog.prototype.getBrandTemplateInternalName = function () { return this.item.navigationInfo.brandTemplateInternalName; };
    BundleBrandingDialog.prototype.getBrandThemeInternalName = function () { return this.item.navigationInfo.brandThemeInternalName; };
    BundleBrandingDialog.prototype.getBrandingSteps = function () {
        return [{
                title: this.i18N.tr('bundle'),
                step: StepEnum.BundleBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("bundle-branding-text"),
                        vm: this.bundleBrandingText,
                        show: true,
                        view: '../../app/admin/bundle/dialogs/branding-steps/bundle-branding-text.html'
                    },
                    {
                        title: this.i18N.tr("bundle-branding-images"),
                        vm: this.bundleBrandingImages,
                        show: true,
                        view: '../../app/admin/bundle/dialogs/branding-steps/bundle-branding-images.html'
                    },
                    {
                        title: this.i18N.tr("bundle-branding-colors"),
                        vm: this.bundleBrandingColors,
                        show: true,
                        view: '../../app/admin/bundle/dialogs/branding-steps/bundle-branding-colors.html'
                    }
                ]
            },
            {
                title: this.i18N.tr('assets'),
                step: StepEnum.BundleAssets,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("bundle-branding-images"),
                        vm: this.bundleBrandingAssets,
                        show: true,
                        view: '../../app/admin/bundle/dialogs/branding-steps/bundle-branding-assets.html'
                    }
                ]
            },
            {
                title: this.i18N.tr('ads'),
                step: StepEnum.BundleAdsBranding,
                show: true,
                view: "",
                children: [
                    {
                        title: this.i18N.tr("bundle-branding-ads"),
                        vm: this.bundleBrandingAds,
                        show: true,
                        view: '../../app/admin/bundle/dialogs/branding-steps/bundle-branding-ads.html'
                    }
                ]
            }];
    };
    BundleBrandingDialog.prototype.getBrandDetails = function () {
        return {
            brandId: this.item.navigationInfo.brandId,
            brandName: this.item.navigationInfo.brandName,
            brandLanguages: this.item.navigationInfo.brandLanguages
        };
    };
    BundleBrandingDialog.prototype.getImages = function () {
        return [this.bundleBrandingImages.model, this.bundleBrandingAds.model.image];
    };
    BundleBrandingDialog.prototype.getRoute = function () {
        var key = BundleKeyHelper.getKey(this.item.name);
        return "bundle/".concat(this.item.bundleId, "/").concat(key);
    };
    BundleBrandingDialog.prototype.includesNavigationInfo = function () {
        return true;
    };
    BundleBrandingDialog.prototype.getRouteAdditionalData = function () {
        return "bundleId=".concat(this.item.bundleId);
    };
    BundleBrandingDialog = __decorate([
        autoinject,
        __metadata("design:paramtypes", [Element, NotificationClientService, I18N, EventAggregator,
            LookupClientService, CacheClient, BundleBrandingText, BundleBrandingImages,
            BundleBrandingAds, BundleBrandingColors, BundleBrandingAssets,
            TokenClient, DialogClientService, BrandClientService,
            AttachmentClientService, JsonLockClientService])
    ], BundleBrandingDialog);
    return BundleBrandingDialog;
}(BrandingPreviewBase));
export { BundleBrandingDialog };
